import React, { Suspense, useState } from "react";

import TabButton from "../../../common/TabButton/TabButton";
import AndroidPluginLibrary from "./Tabs/Library/AndroidPluginLibrary";
import AndroidPluginDeletedFiles from "./Tabs/DeletedFiles/AndroidPluginDeletedFiles";
import AndroidPluginFiles from "./Tabs/Files/AndroidPluginFiles";
import AndroidPluginSharedPreferences from "./Tabs/SharedPreferences/AndroidPluginSharedPreferences";
import Spinner from "../../../common/Spinner/Spinner";

import "./styles.scss";

const AndroidPlugins = () => {
  const [active, setActive] = useState("Library");

  const onTitleClicked = (title) => {
    setActive(title);
  };

  return (
    <div className="android-plugins">
      <div className="button-block">
        <TabButton title="Library" onClick={onTitleClicked} active={active} />
        <TabButton title="Deleted Files" onClick={onTitleClicked} active={active} />
        <TabButton title="Files" onClick={onTitleClicked} active={active} />
        <TabButton title="Shared Preferences" onClick={onTitleClicked} active={active} />
      </div>
      {active === "Library" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <AndroidPluginLibrary />
        </Suspense>
      ) : active === "Deleted Files" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <AndroidPluginDeletedFiles />
        </Suspense>
      ) : active === "Files" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <AndroidPluginFiles />
        </Suspense>
      ) : active === "Shared Preferences" ? (
        <Suspense
          fallback={
            <div className="spinner-block border">
              <Spinner />
            </div>
          }>
          <AndroidPluginSharedPreferences />
        </Suspense>
      ) : null}
    </div>
  );
};

export default AndroidPlugins;
